import configureAppStore from "../redux/store";
import { accessToken } from "../redux/userDataSlice";
import { API_BASE_URL } from "../config";

var defaultHeaders = {
  Accept: "application/json",
  "Content-Type": "application/json",
};

export const callApi = async (
  method,
  Url,
  bodyParams,
  setloading,
  onSuccess,
  onError,
  count = 0,
  multipart
) => {

  let token = configureAppStore.getState().userDataSlice.token ?? false;
  let refreshToken =
    configureAppStore.getState().userDataSlice.refreshToken ?? false;
  if (multipart) {
    // Don't set Content-Type for multipart/form-data, let browser set it with boundary
    delete defaultHeaders["Content-Type"];
  } else {
    defaultHeaders["Content-Type"] = "application/json";
  }
  if (token) {
    defaultHeaders["Authorization"] = token;
  }

  let fetchObject = {
    method: method,
    headers: defaultHeaders,
    body:
      method == "GET"
        ? null
        : method == "DELETE"
        ? null
        : multipart
        ? bodyParams
        : JSON.stringify(bodyParams),
  };
  if (bodyParams == null) {
    delete fetchObject.body;
  }

  try {
    setloading(true);
    let response = await fetch(Url, fetchObject);
    const text = await response.text();
    let responseJson = {};
    if (text) {
      try {
        responseJson = JSON.parse(text);
      } catch {
        setloading(false);
        onError({ message: "Invalid JSON response" });
        return;
      }
    }
    if (responseJson.status == null) {
      responseJson.status = response.ok
        ? 200
        : response.status >= 400
          ? response.status
          : 500;
    }
    if (responseJson?.message == "jwt expired" && count < 2 && refreshToken) {
      let fetchObject = {
        method: "POST",
        headers: defaultHeaders,
        body: JSON.stringify({
          device: { id: 'admindevice', deviceToken: "adminfcm" },
        }),
      };

      await fetch(`${API_BASE_URL}/user/refresh/${refreshToken}`, fetchObject)
        .then(async (res) => {
          let resJson = await res.json();
          configureAppStore.dispatch(accessToken(resJson.data.accessToken));
          callApi(
            method,
            Url,
            bodyParams,
            setloading,
            onSuccess,
            onError,
            count + 1
          );
        })
        .catch((err) => {
          console.error("Error refreshing token:", err);
        });
    } else if (responseJson?.status < 600) {
      onSuccess(responseJson);
      setloading(false);
    } else {
      onError(responseJson);
      setloading(false);
    }
  } catch (error) {
    setloading(false);
    onError(error);
  }
};
